/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import NodeWrap from '@/components/nodeWrap/index.vue'
import addNode from '@/components/addNode/index.vue'
import { NewReviewModule } from '@/store/modules/newReview'
import { getDeparmentList, getUserList, getReviewById } from '@/api/common'
import { getRoleAuthority } from '@/api/authority'

interface FormData {
  name: string;
  type: string;
  action: string;
  range: Array<any>;
  detail?: string;
  isDelete: number;
  userList: string[];
  departmentList: number[];
}
@Component({
    components: { NodeWrap, addNode }
})
export default class NewReview extends Vue {
  accessibleList: any = []
    rangeSelectShow = false
    inRange = '部门'
    checkRangeUserList: Array<string> = [] // 适用范围内选中的员工 id
    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    checkUserInfo: any = [] // 选中的员工信息，主要用来回显在适用范围的输入框内，与后台返回的deparmentList、userList数据结构基本一致，方便渲染
    checkDeparmentInfo: any = [] // 选中的部门信息
    formData: FormData = {
        name: '', // 名称
        type: '', // 类型
        action: '', // 动作
        range: [], // 适用范围
        detail: '', // 描述
        isDelete: 0,
        departmentList: [],
        userList: []
    }
    formRules = {
        name: [{ required: true, message: '请输入审批流名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择审批类别', trigger: 'change' }],
        range: [{ required: true, message: '请选择适用范围', trigger: ['blur','change'] }],
        detail: [{ required: true, message: '请输入审批流描述', trigger: 'blur' }],
        action: [{ required: true, message: '请选择触发动作', trigger: 'change' }]
    }
    functionsList1: any = [] // 一级类型列表
    functionsList2: any = [] // 二级类型列表
    deparmentList: any = [] // 部门列表
    userList = []
    searchName = '' // 搜索的关键字
    reviewId = NaN // 当点击编辑进入的时候就会有reviewID
    nodeList: any = {} // 审批流节点数据
    editId = null
    isEdit = 0
    timer = null



    // ------ 计算属性 ------
    get stepActive() {
        return NewReviewModule.stepsActive
    }

    // ------ 生命周期 ------
    created() {
      if (this.$route.query.isEdit) {
        this.isEdit = Number(this.$route.query.isEdit)
      }

      this.getFunctions1()
      this.getUserList()
      this.getDeparment()

    }

    // ------ 方法 ------
    async getDeparment(name?: string) {

      const data: any = await getDeparmentList({ name })
      this.deparmentList = data

    }

    async getUserList(name?: string ) {

      const data: any = await getUserList({ name })
      this.userList = data

    }

    async getFunctions1() {
      const data: any = await getRoleAuthority({ id: 0 })
      this.functionsList1 = data.filter(item => item.isReview )
      // 为了使接口读取和代码按照预期顺序执行
      if(this.$route.query.id){
        this.reviewId = Number(this.$route.query.id)
        this.getReviewById()
      }
    }

    getFunctions2() {
      const obj = this.functionsList1.filter(item => item.id === this.formData.type)[0]
      this.functionsList2 = obj.functions.filter(item => item.isReview)
    }

    async getReviewById() {
      const data: any = await getReviewById({ id: this.reviewId })
      const { name, detail, functionsLevel1Id, functionsLevel2Id, departmentList, userList, nodeObject } = data
      this.nodeList = nodeObject
      this.formData.name = name
      this.formData.detail = detail
      this.formData.type = functionsLevel1Id
      this.formData.action = functionsLevel2Id
      // this.checkDeparmentInfo = departmentList
      this.checkUserInfo = userList
      departmentList.map(item => {
        this.checkDeparmentInfo.push({
          department:item.department,
          departmentId: item.department.id
        })
      })
      // userList.map(item => {
      //   this.checkUserInfo.push({
      //     user: item,
      //     userId: item.id
      //   })
      // })

      this.checkRangeDepartmentList = departmentList.map(item => item.department.id)
      // this.checkRangeUserList= userList.map(item => item.user.id).filter(item => item);
      // this.checkRangeDepartmentList = departmentList.map(item => item.department.id)
      this.checkRangeUserList= userList.map(item => item.user.id).filter(item => item);
      this.getFunctions2()
    }

    changeFunctions1() {
      this.formData.action = ''
      this.getFunctions2()
    }

    chooseDepartment(checkedKeys,checkedData){
      // 取消勾选
    const [accessibleList,getCheckedKeys] = [this.accessibleList,(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
      // 循环删除this.accessibleList中的项
      for(const i in accessibleList){
          if(accessibleList[i].id == checkedKeys.id){
              this.accessibleList.splice(i,1);
              return;
          }
      }
      // 添加勾选
      const [arr,newArr] = [[],(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
      arr.push(checkedKeys);
      function dealData(arr,newArr){
          for(const i in arr){
              newArr.push(arr[i].id);
              dealData(arr[i].children,newArr);
          }
      }
      // newArr代表获取出来的当前节点以及其下的所有子节点的id
      dealData(arr,newArr);
      (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
      // newJsonArr代表所有选中的节点
      const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
      this.accessibleList = newJsonArr;
      this.checkDeparmentInfo = []

      newJsonArr.map(item => {
        this.checkDeparmentInfo.push({
            department: {
              name: item.name,
              detail: null,
              id: item.id
            },
            departmentId: item.id
        })
      })
      // this.checkDeparmentInfo = newJsonArr
  }

  treeChange(item: any, itembol: boolean) {
    if(itembol) {
    //   if(this.checkRangeDepartmentList.includes(item.id)) return false
    // //   this.checkRangeDepartmentList.push(item.id)
    //   this.checkDeparmentInfo.push({
    //     department: {
    //       name: item.name,
    //       detail: null,
    //       id: item.id
    //     },
    //     departmentId: item.id
    //   })
      const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
      const arrDeptId = []
      res.forEach((item) => {
          arrDeptId.push({
              department: {
                name: item.name,
                detail: null,
                id: item.id
              },
              departmentId: item.id
          })
      })
      this.checkDeparmentInfo = arrDeptId
    } else {
    //   this.checkRangeDepartmentList.splice(this.checkRangeDepartmentList.indexOf(item.id),1)
      this.checkDeparmentInfo.map((t: any, i: number) => {
          if(t.departmentId === item.id){
            this.checkDeparmentInfo.splice(i, 1)
          }
      });
    }
    this.formData.departmentList = this.checkDeparmentInfo
  }

    changeInRange(type: string) {
      this.inRange = type
      this.searchName = ''
    }

    changeCheckUserInfo(item: { id: string; realName: string }, bol: boolean) {
      if(bol) {
        this.checkUserInfo.push({
          'userId': item.id,
          'user': item
        })
      } else {
        this.checkUserInfo = this.checkUserInfo.filter(user => user.userId !== item.id)
      }
      this.formData.userList = this.checkUserInfo
    }

  onSearchName() {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      if (this.inRange === '部门') this.getDeparment(this.searchName)
      if (this.inRange === '员工') this.getUserList(this.searchName)
    }, 1000)
  }

    clearRangeDeparmentItem(id: number) {
      console.log(id)
      // if(!this.$route.query.id){
      //   let arr = []
      //   console.log(this.checkDeparmentInfo)
      //   this.checkDeparmentInfo = this.checkDeparmentInfo.filter((item: any) => item.departmentId != id);
      //   for(var i in this.checkDeparmentInfo){
      //       arr.push(this.checkDeparmentInfo[i].department)
      //       this.checkRangeDepartmentList.push(this.checkDeparmentInfo[i].departmentId)
      //   }
      //   (this.$refs.tree as HTMLFormElement).setCheckedNodes(arr)
      // }else if(this.$route.query.id){
      //   const index = this.checkRangeDepartmentList.indexOf(id)
      //   this.checkRangeDepartmentList.splice(index,1)
      //   this.checkDeparmentInfo = this.checkDeparmentInfo.filter(item => item.departmentId != id);
      //   this.formData.departmentList = this.checkDeparmentInfo;
      //   (this.$refs.tree as HTMLFormElement).setCheckedKeys(this.checkRangeDepartmentList, true)
      // }
      const arr = []
      this.checkDeparmentInfo = this.checkDeparmentInfo.filter((item: any) => item.departmentId != id);
      for(const i in this.checkDeparmentInfo){
          arr.push(this.checkDeparmentInfo[i].department)
      }
      (this.$refs.tree as HTMLFormElement).setCheckedNodes(arr)
    }

    clearRangeUserItem(id: string) {
      this.checkRangeUserList.splice(this.checkRangeUserList.indexOf(id), 1)
      this.checkUserInfo = this.checkUserInfo.filter((item: any) => item.user.id != id);
      this.formData.userList = this.checkUserInfo
    }

    next() {
      this.formData.range = [ ...this.checkRangeUserList, ...this.checkDeparmentInfo ];
      // let arr = []
      (this.$refs['form']as HTMLFormElement).validate((val: any)=>{
        // if(this.checkDeparmentInfo.length == 0 || this.checkUserInfo.length == 0){
        //   this.$message.error('请选择适用范围')
        //   return
        // }
        if(val) {
          const obj = {
            nodeObject: this.nodeList,
            conditionList: [],
            infoNode: 0,
            types: '2',
            editFile: [],
            approvalPersonList: {
              users:  this.checkUserInfo,
              deparments: this.checkDeparmentInfo
            },
          }
          if(this.nodeList.types !== '2') {
            this.nodeList = obj
          } else {
            this.nodeList.approvalPersonList = obj.approvalPersonList
          }
          this.checkRangeDepartmentList = []
          this.checkDeparmentInfo.forEach((item) => {
            this.checkRangeDepartmentList.push(item.departmentId)
          })
          console.log(this.checkRangeDepartmentList)
          this.formData.userList = this.checkRangeUserList
          this.formData.departmentList = this.checkRangeDepartmentList
          NewReviewModule.setStepsAvtive(1)
        } else {
          this.$message.error('请将审批流的基本信息填写完整')
        }

      })
    }

    // ------ 监听 ------
    @Watch('nodeList', {deep: true})
    WatchNodeList(val: any) {
      // console.log(val);
    }
}
